import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { ChartModule } from 'primeng/chart';
@Component({
  selector: 'app-dashboard',
  imports: [
    ButtonModule,
    RouterModule,
    CardModule,
    ToggleSwitchModule,
    ChartModule
  ],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss'
})
export class DashboardComponent {
  totalSpendBalanceData: any = {};
  lineOptions: any = {};

  isEmpty: boolean = false;

  ngOnInit() {
    this.initLineChart();
    this.getSpendAndBalance();
  }

  initLineChart() {
    const documentStyle = getComputedStyle(document.documentElement);
    const textColor = documentStyle.getPropertyValue('--text-color');

    this.lineOptions = {
      maintainAspectRatio: false,
      aspectRatio: 0.6,
      plugins: {
        pieTextPlugin: false,
        customPlugin: false,
        legend: {
          display: false,
          labels: {
            color: textColor,
            fontFamily: "'Nunito Sans', sans-serif"
          }
        }
      },
      scales: {
        x: {
          ticks: {
            color: "rgba(43, 48, 52, 0.40)",
            stepSize: 1,
            autoSkip: false,
            fontFamily: "'Nunito Sans', sans-serif"
          },
          grid: {
            display: false,
          },
        },
        y: {
          ticks: {
            color: "rgba(43, 48, 52, 0.40)",
            maxTicksLimit: 7,
            padding: 30,
            fontFamily: "'Nunito Sans', sans-serif"
          },
          grid: {
            tickMarkLength: 20,
            color: "#EAEAEA",

          },
        }
      }
    };
    this.totalSpendBalanceData = {
      labels: [],
      datasets: [
        {
          data: [],
          fill: true,
          borderColor: [
            "green",
            "green",
            "green",
            "green",
          ],
          tension: 0.1,
          pointBackgroundColor: '#14AB5F',
          borderWidth: 1,
          backgroundColor: [
            "green",
            "green",
            "green",
            "green",
          ]

        },

      ]
    };
  }

  getSpendAndBalance() {
    this.totalSpendBalanceData = {
      labels: ["1 JAN", "2 JAN", "3 JAN", "4 JAN", "5 JAN"],
      datasets: [
        {
          data: [1000, 2000, 3000, 40000, 50000],
          fill: true,
          tension: 0.5,
          borderColor: "#5BC4FF",
          borderWidth: 1,
          pointBackgroundColor: "#5BC4FF",
          pointBorderColor: "#5BC4FF",
          backgroundColor: (context: any) => {
            const bgColor = [
              '#5bc4ff08',
              '#5bc4ff08',
              '#5bc4ff08',
              '#5bc4ff08',
            ];
            if (!context.chart.chartArea) {
              return;
            }
            const { ctx, data, chartArea: { top, bottom } } = context.chart;
            const gredientBg = ctx.createLinearGradient(0, top, 0, bottom);
            gredientBg.addColorStop(0, bgColor[0]);
            gredientBg.addColorStop(0.5, bgColor[0]);
            gredientBg.addColorStop(1, bgColor[1]);
            return gredientBg;
          }
        },
      ]
    };
  }

}
